
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/events/[eventId]/posters",
      function () {
        return require("private-next-pages/events/[eventId]/posters/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/events/[eventId]/posters"])
      });
    }
  